import create from 'zustand';
import * as NewspapersAPI from '../../api/Newspapers';
import * as StoriesAPI from '../../api/Stories';
import { Edition, Newspaper, Story } from '../../types/models/Newspaper';

export interface NewspaperState {
  newspapers: Newspaper[];
  currentNewspaper?: Newspaper;
  currentEditions: Edition[];
  currentStories: Story[];
  setNewspapers: (newspapers: Newspaper[]) => void;
  setCurrentNewspaper: (newspaper: Newspaper | undefined) => void;
  loadNewspapers: () => Promise<void>;
  loadEditions: (newspaperId: string) => Promise<void>;
  loadStories: (newspaperId: string, editionId: string) => Promise<void>;
  addNewspaper: (newspaper: Newspaper) => void;
  addEdition: (edition: Edition) => void;
  setStories: (stories: Story[]) => void;
}

export const useNewspaperStore = create<NewspaperState>((set) => ({
  newspapers: [],
  currentNewspaper: undefined,
  currentEditions: [],
  currentStories: [],
  setNewspapers: (newspapers) => set({ newspapers }),
  setCurrentNewspaper: (newspaper) => set({ currentNewspaper: newspaper }),
  loadNewspapers: async () => {
    try {
      const response = await NewspapersAPI.getAll();
      set({ newspapers: response.data.data });
    } catch {
      set({ newspapers: [] });
    }
  },
  loadEditions: async (newspaperId: string) => {
    try {
      const response = await NewspapersAPI.getEditions(newspaperId);
      set({ currentEditions: response.data.data });
    } catch {
      set({ currentEditions: [] });
    }
  },
  loadStories: async (newspaperId: string, editionId: string) => {
    try {
      const response = await StoriesAPI.getAll(newspaperId, editionId);
      set({ currentStories: response.data.data });
    } catch {
      set({ currentStories: [] });
    }
  },
  addNewspaper: (newspaper) => set((state) => ({
    newspapers: [newspaper, ...state.newspapers],
  })),
  addEdition: (edition) => set((state) => ({
    currentEditions: [edition, ...state.currentEditions],
  })),
  setStories: (stories) => set({ currentStories: stories }),
}));
